<template>
  <Btn :label="$t('ELE0021')" @click="onClick" icon="mdi-arrow-left" color="white" outlined />
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'

export default {
  name: 'BtnBack',

  components: { Btn },

  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    onClick() {
      this.$router.back()
    },
  },
}
</script>
